import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.less';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

const CustomTooltip = ({ payload = emptyArray, children = emptyObject }) => {
  return <div className={style['custom-tooltip']}>{React.cloneElement(children, { payload })}</div>;
};

CustomTooltip.propTypes = {
  children: PropTypes.object,
  payload: PropTypes.array,
};

export default CustomTooltip;
